class OmerellaSizeChart extends HTMLElement {
  /** @type {HTMLDialogElement | null} */
  #dialog = null;

  /** @type {HTMLElement | null} */
  #slidesWrap = null;

  /** @type {HTMLImageElement[]} */
  #slides = [];

  /** @type {number} */
  #index = 0;

  /** @type {AbortController | null} */
  #abort = null;

  connectedCallback() {
    this.#dialog = this.querySelector('.omerella-size-chart-modal');
    this.#slidesWrap = this.querySelector('[data-size-chart-slides]');
    this.#slides = [...this.querySelectorAll('.omerella-size-chart-modal__slide')];

    if (this.#abort) return;

    this.#abort = new AbortController();
    const { signal } = this.#abort;

    document.addEventListener('click', this.#onDocumentClick, { signal });
    this.#dialog?.addEventListener('click', this.#onDialogClick, { signal });
    document.addEventListener('keydown', this.#onKeydown, { signal });

    this.querySelector('[data-size-chart-prev]')?.addEventListener('click', () => this.#step(-1), { signal });
    this.querySelector('[data-size-chart-next]')?.addEventListener('click', () => this.#step(1), { signal });

    this.#syncNav();
  }

  disconnectedCallback() {
    this.#abort?.abort();
    this.#abort = null;
    this.#dialog?.close();
    document.documentElement.classList.remove('omerella-size-chart-open');
  }

  /** @param {Event} event */
  #onDocumentClick = (event) => {
    const target = /** @type {HTMLElement} */ (event.target);
    const openBtn = target.closest('[data-size-chart-open]');
    if (!openBtn) return;

    const controlsId = openBtn.getAttribute('aria-controls');
    if (controlsId && this.#dialog?.id !== controlsId) return;

    event.preventDefault();
    this.#open();
  };

  /** @param {Event} event */
  #onDialogClick = (event) => {
    const target = /** @type {HTMLElement} */ (event.target);
    if (target.closest('[data-size-chart-close]') || target === this.#dialog) {
      event.preventDefault();
      this.#close();
    }
  };

  /** @param {KeyboardEvent} event */
  #onKeydown = (event) => {
    if (!this.#dialog?.open) return;
    if (event.key === 'Escape') this.#close();
    if (event.key === 'ArrowLeft') this.#step(-1);
    if (event.key === 'ArrowRight') this.#step(1);
  };

  #open() {
    if (!this.#dialog) return;
    this.#index = 0;
    this.#showSlide(0);
    this.#dialog.showModal();
    document.documentElement.classList.add('omerella-size-chart-open');
  }

  #close() {
    this.#dialog?.close();
    document.documentElement.classList.remove('omerella-size-chart-open');
  }

  /** @param {number} delta */
  #step(delta) {
    if (!this.#slides.length) return;
    const next = (this.#index + delta + this.#slides.length) % this.#slides.length;
    this.#showSlide(next);
  }

  /** @param {number} index */
  #showSlide(index) {
    this.#index = index;
    this.#slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
    });
    this.#syncNav();
  }

  #syncNav() {
    const prev = this.querySelector('[data-size-chart-prev]');
    const next = this.querySelector('[data-size-chart-next]');
    const single = this.#slides.length <= 1;
    if (prev instanceof HTMLButtonElement) prev.disabled = single;
    if (next instanceof HTMLButtonElement) next.disabled = single;
    if (this.#slidesWrap) {
      this.#slidesWrap.dataset.slideCount = String(this.#slides.length);
    }
  }
}

if (!customElements.get('omerella-size-chart')) {
  customElements.define('omerella-size-chart', OmerellaSizeChart);
}
